<template>
  <w-settings-detail title="OID 설정" :menu="menu" :default-active-menu="defaultMenu" @change="onChangeMenu">
    <component slot="activeView" :is="activeMenu" :activeView="activeMenu"></component>
  </w-settings-detail>
</template>

<script>
import WSettingsDetail from '@/components/template/SettingsDetail';
import WVendorModelOidSettings from './VendorModelOidSettings';
import WPerformanceOidSettings from './PerformanceOidSettings';
import WUserDefineOidSettings from './UserDefineOidSettings';
import WConfigOidSettings from './ConfigOidSettings';

const defaultMenu = 'WVendorModelOidSettings';
export default {
  name: 'WOidSettings',
  components: {
    WSettingsDetail,
    WVendorModelOidSettings,
    WPerformanceOidSettings,
    WUserDefineOidSettings,
    WConfigOidSettings,
  },
  data() {
    return {
      defaultMenu,
      activeMenu: defaultMenu,
      menu: [
        {
          id: 'WVendorModelOidSettings',
          name: '벤더/모델 OID 사전',
          active: false,
        },
        {
          id: 'WPerformanceOidSettings',
          name: '성능 OID 사전',
          active: false,
        },
        {
          id: 'WConfigOidSettings',
          name: '구성 OID 사전',
          active: false,
        },
        {
          id: 'WUserDefineOidSettings',
          name: '사용자 정의 OID',
          active: false,
        },
      ],
    };
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/index.vue